import React from "react";

export default function BackIcon() {
  return (
    <React.Fragment>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.78912 10L0 5L4.78912 0L5.61225 0.848215L2.22352 4.38616H10V5.61384H2.22352L5.61225 9.14062L4.78912 10Z"
          fill="#222222"
          fillOpacity="0.5"
        />
      </svg>
    </React.Fragment>
  );
}
